"use client";

import { useState } from "react";
import RPViewer from "./RPViewer";

function EnviarRP({ onClose, onSubmit, userRole, solicitud, rpFormulario }) {
  const [archivoRut, setArchivoRut] = useState(null);
  const [archivoMinuta, setArchivoMinuta] = useState(null);

  const [estadoRp, setEstadoRp] = useState("");
  const [archivoRpRespuesta, setArchivoRpRespuesta] = useState(null);
  const [showRpViewer, setShowRpViewer] = useState(false);

  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ NUEVOS CAMPOS (solo cuando Presupuesto aprueba)
  const [fechaDocumento, setFechaDocumento] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");

  const isPresupuestoView = userRole === "presupuesto" && !!solicitud;
  const isPresupuestoResponse =
    isPresupuestoView &&
    (solicitud.status === "pending" || solicitud.status === "pendiente");

  const yaRespondido =
    isPresupuestoView &&
    !!solicitud?.response_status &&
    solicitud.status !== "pending" &&
    solicitud.status !== "pendiente";

  const handleEnviar = async () => {
    setLoading(true);

    try {
      if (isPresupuestoResponse) {
        // ====== RESPUESTA DE PRESUPUESTO ======
        if (!estadoRp) {
          alert("Debe seleccionar el estado del RP");
          return;
        }

        if (estadoRp === "aprobado") {
          if (!fechaDocumento) {
            alert("Debe seleccionar la fecha del documento (RP)");
            return;
          }
          if (!numeroDocumento.trim()) {
            alert("Debe ingresar el número del documento (RP)");
            return;
          }
        }

        if (estadoRp === "negado" && !motivoRechazo.trim()) {
          alert("Debe ingresar el motivo del rechazo");
          return;
        }

        const data = {
          requestId: solicitud.id,
          approved: estadoRp === "aprobado",
          responseAttachments: archivoRpRespuesta ? [archivoRpRespuesta] : [],
          notes: motivoRechazo || "",

          // ✅ IMPORTANTE: estos nombres deben ir tal cual para el backend SQL
          fecha_documento: estadoRp === "aprobado" ? fechaDocumento : null,
          numero_documento: estadoRp === "aprobado" ? numeroDocumento.trim() : null,
        };

        await onSubmit(data);
      } else {
        // ====== ENVÍO NORMAL (SOLICITANTE) ======
        if (!archivoRut || !archivoMinuta) {
          alert("Debe adjuntar el RUT y la Minuta antes de enviar.");
          return;
        }

        const data = {
          type: "RP",
          attachments: {
            rut: archivoRut,
            minuta: archivoMinuta,
          },
        };

        await onSubmit(data);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al procesar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeEstado = (value) => {
    setEstadoRp(value);

    // Limpieza para evitar datos “pegados”
    if (value === "aprobado") {
      setMotivoRechazo("");
    }
    if (value === "negado") {
      setFechaDocumento("");
      setNumeroDocumento("");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "2rem",
          borderRadius: "10px",
          width: "500px",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        }}
      >
        <h3>{isPresupuestoView ? "Solicitud RP - Detalles" : "Enviar RP"}</h3>

        {!isPresupuestoView && (
          <>
            <div style={{ marginBottom: "1rem" }}>
              <label>
                <strong>Cargar RUT *</strong>
              </label>
              <br />
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setArchivoRut(e.target.files[0])}
              />
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label>
                <strong>Cargar Minuta *</strong>
              </label>
              <br />
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setArchivoMinuta(e.target.files[0])}
              />
            </div>
          </>
        )}

        {isPresupuestoResponse && (
          <>
            <div style={{ marginBottom: "1rem" }}>
              <label>
                <strong>Estado del RP *</strong>
              </label>
              <br />
              <div style={{ marginTop: "0.5rem", display: "flex", gap: "2rem" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <input
                    type="radio"
                    name="estadoRp"
                    value="aprobado"
                    checked={estadoRp === "aprobado"}
                    onChange={(e) => handleChangeEstado(e.target.value)}
                    style={{ accentColor: "#28a745" }}
                  />
                  Aprobado
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <input
                    type="radio"
                    name="estadoRp"
                    value="negado"
                    checked={estadoRp === "negado"}
                    onChange={(e) => handleChangeEstado(e.target.value)}
                    style={{ accentColor: "#dc3545" }}
                  />
                  Negado
                </label>
              </div>
            </div>

            {/* ✅ SOLO SI APRUEBA: FECHA + NÚMERO */}
            {estadoRp === "aprobado" && (
              <>
                <div style={{ marginBottom: "1rem" }}>
                  <label>
                    <strong>Fecha del documento (RP) *</strong>
                  </label>
                  <br />
                  <input
                    type="date"
                    value={fechaDocumento}
                    onChange={(e) => setFechaDocumento(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "1rem" }}>
                  <label>
                    <strong>Número del documento (RP) *</strong>
                  </label>
                  <br />
                  <input
                    type="text"
                    value={numeroDocumento}
                    onChange={(e) => setNumeroDocumento(e.target.value)}
                    placeholder="Ej: RP-1234-2025"
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </div>
              </>
            )}

            {estadoRp === "negado" && (
              <div style={{ marginTop: "1rem" }}>
                <label>
                  <strong>Motivo del rechazo *</strong>
                </label>
                <br />
                <textarea
                  value={motivoRechazo}
                  onChange={(e) => setMotivoRechazo(e.target.value)}
                  placeholder="Ingrese el motivo del rechazo..."
                  style={{
                    width: "100%",
                    minHeight: "80px",
                    padding: "0.5rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    resize: "vertical",
                    marginTop: "0.5rem",
                  }}
                />
              </div>
            )}

            <div style={{ marginBottom: "1rem" }}>
              <label>
                <strong>Adjuntar RP (opcional)</strong>
              </label>
              <br />
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setArchivoRpRespuesta(e.target.files[0])}
              />
            </div>
          </>
        )}

        {/* Resumen cuando ya está respondido */}
        {yaRespondido && (
          <div
            style={{
              marginBottom: "1rem",
              padding: "1rem",
              backgroundColor:
                solicitud.response_status === "aprobado" ? "#d4edda" : "#f8d7da",
              borderRadius: "5px",
            }}
          >
            <h4>Respuesta:</h4>
            <p>
              <strong>Estado:</strong>{" "}
              {solicitud.response_status === "aprobado" ? "Aprobado" : "Negado"}
            </p>

            {solicitud.response_status === "aprobado" && (
              <>
                <p>
                  <strong>Fecha documento:</strong>{" "}
                  {solicitud.fecha_documento || "-"}
                </p>
                <p>
                  <strong>Número documento:</strong>{" "}
                  {solicitud.numero_documento || "-"}
                </p>
              </>
            )}

            {solicitud.response_status === "negado" && (
              <div style={{ marginTop: "0.5rem" }}>
                <strong>Motivo del rechazo:</strong>
                <div
                  style={{
                    marginTop: "0.25rem",
                    padding: "0.5rem",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffeaa7",
                    borderRadius: "4px",
                    fontSize: "0.9rem",
                  }}
                >
                  {solicitud.motivoRechazo || "-"}
                </div>
              </div>
            )}

            {Array.isArray(solicitud.response_attachments) &&
              solicitud.response_attachments.length > 0 && (
                <div style={{ marginTop: "0.75rem" }}>
                  <strong>RP adjunto:</strong>
                  {solicitud.response_attachments.map((file, index) => (
                    <div key={index}>
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007bff", textDecoration: "underline" }}
                      >
                        {file.name}
                      </a>
                    </div>
                  ))}
                </div>
              )}
          </div>
        )}

       

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
          <button onClick={onClose}>
            {isPresupuestoView && solicitud?.status === "aprobado"
              ? "Cerrar"
              : "Cancelar"}
          </button>

          {(!isPresupuestoView || isPresupuestoResponse) && (
            <button
              onClick={handleEnviar}
              disabled={loading}
              style={{
                backgroundColor: loading
                  ? "#9ca3af"
                  : isPresupuestoResponse
                  ? "#28a745"
                  : "#1e40af",
                color: "#fff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "5px",
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              {loading && (
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    border: "2px solid #ffffff",
                    borderTop: "2px solid transparent",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                />
              )}
              {loading ? "Enviando..." : isPresupuestoResponse ? "Responder" : "Enviar"}
            </button>
          )}
        </div>
      </div>

      {/* Visor RP */}
      {showRpViewer && rpFormulario && (
        <RPViewer rpData={rpFormulario} onClose={() => setShowRpViewer(false)} />
      )}
    </div>
  );
}

export default EnviarRP;